const PaymentMode = [
    {
        value: 'IMPS',
        label: 'IMPS',
    },
    {
        value: 'NEFT',
        label: 'NEFT',
    },
    {
        value: 'RTGS',
        label: 'RTGS',
    },
    {
        value: 'Cheque',
        label: 'Cheque',
    },
]

export { PaymentMode }